import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { errorMessages } from '~/constants/errorMessages.ts';
import api from '~/libs/api';
import { TTariff, TTariffResponse } from './types';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { useSelector } from 'react-redux';
import { RootState } from '~/store/store';

const getTarrifs = (token: string) => async () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
  try {
    const { data } = await api.get(`/dictionary-service/dictionary/contragent_tariff`, { headers });
    return data;
  } catch {
    throw Error(errorMessages.SERVICE_UNAVAILABLE);
  }
};

export const useTariffsQuery = (id?: number | string) => {
  const token = useSelector((state: RootState) => state.users.token);
  const { data, error, isLoading, isError } = useQuery({
    queryKey: ['tarriffs'],
    queryFn: getTarrifs(token),
    staleTime: 30 * 60 * 1000,
  });

  const parsedTarriffs: TTariff[] = useMemo(() => {
    if (!data) return [];
    return (
      data.filter(
        (tarriff: TTariffResponse) => tarriff?.contragentType?.cid === id?.toString()
      )?.[0]?.tariffPackages || []
    );
  }, [data, id]);

  const autocompleteTarrifs: TAutocompleteOption[] = useMemo(() => {
    if (!parsedTarriffs) return [];
    return (
      parsedTarriffs.map((tarriff: TTariff) => ({
        label: tarriff.name,
        value: tarriff.id.toString(),
      })) || []
    );
  }, [parsedTarriffs]);

  return { tarrifs: parsedTarriffs, autocompleteTarrifs, error, isLoading, isError };
};
